import { Separator } from '@/components/ui/separator';
import { currencyFormat } from '@/helpers/stringHelpers';

const CartSummary = ({ cart }) => {
  return (
    <div>
      <Separator className="mb-4" />
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span>Subtotal</span>
          <span>{currencyFormat(cart.subTotal)}</span>
        </div>
        {cart.taxSummary.map((tax) => (
          <div key={tax.label} className="flex justify-between">
            <span>{tax.label}</span>
            <span>{currencyFormat(tax.totalAmount)}</span>
          </div>
        ))}
        <div className="flex justify-between font-medium text-base">
          <span>Total</span>
          <span>{currencyFormat(cart.total)}</span>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
